import { SelectDropdown } from "../../types";
import { gradesArray } from "../grades";

export const gradeSelect: SelectDropdown = {
	selectName: 'grade',
	defaultValue: 'all',
	minWidth: 130,
	selectMenu: [{ value: 'all', label: 'כל הכיתות' }, ...gradesArray?.map(({ id, value }) => ({ value: id, label:`כיתות ${value}` }))]
};